export default __webpack_public_path__ + "static/media/tw_icon.ea5fe387.svg";